import React from "react";
import Login from "../../../Login";
import LayoutCompra from "../../../Global/LayoutCompra";
import { isLogged } from "../../../../utils/Tools";
import { withRouter } from "react-router-dom";

const LoginCdr = (props) => {

  if (isLogged()) props.history.push("/hoteles/proceso-compra/carga-pasajeros/");

  const handleLoginEnCompraClick = (estado) => {
    if (estado) {
      props.history.push("/hoteles/proceso-compra/carga-pasajeros/");
    }
  };

  return (
    <LayoutCompra paso="1">
      <Login
        mostrarToastContainer={false}
        onLoginClickEnCompra={handleLoginEnCompraClick}
      />
    </LayoutCompra>
  );
};

export default withRouter(LoginCdr);



// WEBPACK FOOTER //
// ./src/components/Hoteles/ProcesoCompraCdr/LoginCdr/index.js